import React from 'react';
import { BloodGlucoseChart } from 'components/ProgressTab/BloodGlucoseChart';
import { BloodGlucoseLegend } from 'components/ProgressTab/BloodGlucoseLegend';
import { BloodGlucoseWeekSeries, mealsWithData } from 'features/progress/utils/bloodGlucoseMeals';

export interface BloodSugarChartProps {
  series: BloodGlucoseWeekSeries;
  yRange: { min: number; max: number };
}

export const BloodSugarChart = ({ series, yRange }: BloodSugarChartProps) => {
  const meals = mealsWithData(series);

  return (
    <BloodGlucoseChart
      series={series}
      meals={meals}
      yRange={yRange}
      alignToTitle
      legend={series.hasReadings ? <BloodGlucoseLegend meals={meals} /> : undefined}
    />
  );
};
